import { render } from "./ClientCompetitors.vue?vue&type=template&id=95b8990e"
import script from "./ClientCompetitors.vue?vue&type=script&lang=js"
export * from "./ClientCompetitors.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__